import { TextField } from 'module/types/filter-field/field/filterable-field';
import { FC, useCallback } from 'react';
import styled from 'styled-components';
import { EditableProps } from './editable-props';
import { RichTextEditorInput } from '../../atoms/rich-text-editor-input/editor';

interface Props extends Partial<EditableProps<string>> {
  field: TextField;
}

/* Its an dummy value for the multi line text field. Need to check with design team for the max width */
const StyledRichTextEditorInput = styled(RichTextEditorInput)`
  max-width: 350px;
  min-width: 300px;
`;

export const MultiLineTextFieldValue: FC<React.PropsWithChildren<Props>> = ({
  field,
  editable,
  onChange,
}) => {
  const enhancedBreaklineValue = useCallback(() => {
    return field.value?.replaceAll('\n', '<br>');
  }, [field.value]);

  return (
    <StyledRichTextEditorInput
      //className={styles.multiline__rte}
      value={enhancedBreaklineValue() ?? ''}
      onChange={(_data) => onChange?.(_data as string)}
      readonly={!editable}
      //noVariables
      //testId={`ag-grid.${field.type}.editor`}
      // @TODO: @kadhirr how do I only enable it for projects view? What about filters?
      //enableAiFill={enableAiFills}
    />
  );
};
